<div class="timecard-account-select-panel layout-column" appBringozIdGenerator="accountSelectPanel">

  <!--Search Box-->
  <div class="layout-row padding-10">
    <bz-search-input class="flex"
                     appBringozIdGenerator="accountSearchInput"
                     [placeholder]="'Search Account' | translate"
                     [ariaLabel]="'Search Account' | translate"
                     [value]="queryString()"
                     (valueChange)="onQueryChange($event)">
    </bz-search-input>
  </div>

  @if (isInitialLoading()) {
    <div class="flex layout-column layout-align-center-center fade-element-in-only">
      <bz-spinner size="lg" [label]="'Loading' | translate"></bz-spinner>
    </div>
  } @else if (isEmpty()) {
    <div class="flex layout-column layout-align-center-center fade-element-in-only">
      <bz-empty-state [title]="'No Accounts Found' | translate"></bz-empty-state>
    </div>
  } @else {
    <div class="flex layout-column overflow-auto account-list" (scroll)="onScroll($event)">
      <bz-radio-group name="account"
                      appBringozIdGenerator="accountOptions"
                      [value]="selectedId"
                      [ariaLabel]="'Account' | translate"
                      (valueChange)="onSelectId($event)">
        @for (account of accounts(); track account.id) {
          <bz-radio class="account-item" [value]="account.id">{{ account.name }}</bz-radio>
        }
      </bz-radio-group>
    </div>
  }

  <!--Next Page Loading State-->
  @if (isLoading() && !isInitialLoading()) {
    <div class="layout-row layout-align-center-center padding-5">
      <bz-spinner size="sm" [label]="'Loading' | translate"></bz-spinner>
    </div>
  }

</div>
